var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 178,
    viewBox: "0 0 319 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4442_3040",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 319,
    height: 180
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 319,
    height: 182,
    rx: 4,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4442_3040)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -13.043,
    y: -12.3199,
    width: 331.908,
    height: 208.08,
    fill: "#6DC7DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 58.4921H71V213.762H216V58.4921Z",
    fill: "#62BED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 85.0794H20V160.587H89V85.0794Z",
    fill: "#89DEF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 19.1429H87V67H132V19.1429Z",
    fill: "#C1E7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 35.0952H43V59.5556H66V35.0952Z",
    fill: "#037BC1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.b2da29be.svg";
export { ForwardRef as ReactComponent };